module.exports = __webpack_public_path__ + "scala-bc8735a8e3735a864812d9a123a0d007.png";